import React from 'react';
import {usePlannerLayout} from 'components/customer/RoomPlanner/helper/usePlannerLayout';
import {Desktop} from 'shared/components/Header/RoomPlanner/FloatingControls/Desktop';

export const FloatingButtons = () => {
    const {showDesktopHelpButtons} = usePlannerLayout();

    if (!showDesktopHelpButtons) {
        return null;
    }

    return <Desktop />;
};
